import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import './PageMask.css';
import govbr from 'theme/govbr_logo_white.svg';
import signatures from 'theme/logo-aghux-hubrasil-negativo.svg';
import clientLogo from 'theme/client_logo.svg';

import { usePageMaskContext } from 'contexts/PageMaskContext';
import { useHistory } from 'react-router-dom';
// import { TitleBreadscrumbs } from 'components/TitleBreadscrumbs';
import {
  AppBar,
  Box,
  Button,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { useUserContext } from 'store';
import { TitleBreadscrumbs } from 'components/TitleBreadscrumbs';
import {
  HamburgerMenuButton,
  AvatarMenu,
  SidebarMenu,
  AccessibilityButtons,
} from './components';

const testPage = {
  content: () => <h1>Conteúdo</h1>,
  title: 'Pagina Teste',
};

export function PageMask({ children }) {
  const { pageMaskState, handleSidebarEvent } = usePageMaskContext();
  const ContentPage = useMemo(() => children.content, [children]);
  const history = useHistory();

  document.title = `${children.title} | HU Digital - Empresa Brasileira de Serviços Hospitalares`;

  function navigateToHome() {
    history.push('/');
  }

  return (
    <div className="containerPageMask">
      <div className="header">
        <AppBar position="static" color="transparent">
          <Toolbar className="toolbarOptions">
            <div className="headerInitialContent">
              <Box display="flex" alignItems="center">
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >
                  <HamburgerMenuButton
                    isOpen={pageMaskState.sidebarIsOpen}
                    onClick={handleSidebarEvent}
                    className="hamburgerMenuButton"
                  />
                </IconButton>
                <Button onClick={navigateToHome}>
                  <img
                    src={clientLogo}
                    alt="Client Logo Logo"
                    className="clientLogo"
                  />
                </Button>
                <Divider className="dividerHeader hiddenDivider" />
              </Box>
              <div>
                <Box display="flex" justifyContent="space-between">
                  <Typography className="auxiliarTextEbserh">
                    Hospitais Universitários Federais
                  </Typography>
                  {/* {`Gov.br/${user.userData.rolesPerOrganization[0].organizationAlias}`} */}
                </Box>
              </div>
            </div>
            <div className="headerTailContent">
              <a
                className="externalLinkEbserh"
                href="https://gov.br/ebserh"
                target="_blank"
              >
                Gov.br/HU Brasil
              </a>
              <Divider className="dividerHeader hiddenDivider" />
              <Box display="flex">
                <AccessibilityButtons />
              </Box>
              <AvatarMenu />
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <TitleBreadscrumbs currentPageTitle={children.title} />
      <div />
      <div className="main">
        <>
          <SidebarMenu isOpen={pageMaskState.sidebarIsOpen} />
          <ContentPage />
        </>
      </div>

      <div className="footer">
        <div className="footer-signatures">
          <img src={govbr} alt="GovBr Logo" className="govbrLogo" />
          <img
            src={signatures}
            alt="Client Logo Signatures"
            className="clientFooterSignatures"
          />
        </div>
        <div className="version-project">
          <p className="version-project-text">
            Versão Beta - {process.env.REACT_APP_VERSION_TEXT}
          </p>
        </div>
        <div className="footer-license">
          <p className="licenseText">
            As informações provenientes da Rede HU Brasil de dados em Saúde são
            protegidas em conformidade com a
            <strong> Lei 13.709/2018 (LGPD)</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

PageMask.propTypes = {
  children: PropTypes.shape({
    content: PropTypes.element,
    title: PropTypes.string,
  }),
};

PageMask.defaultProps = {
  children: testPage,
};
